export default "__VITE_ASSET___gHRkUEH__"